import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import PopularSection from './components/PopularSection';
import CategoriesSection from './components/CategoriesSection';
import LatestSection from './components/LatestSection';
import FeaturesSection from './components/FeaturesSection';
import NightShowcase from './components/NightShowcase';
import RankingSection from './components/RankingSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import NewsletterSection from './components/NewsletterSection';
import BackToTop from './components/BackToTop';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <PopularSection />
        <CategoriesSection />
        <LatestSection />
        <FeaturesSection />
        <NightShowcase />
        <RankingSection />
        <FaqSection />
        <AboutSection />
        <NewsletterSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}